import { PipeTransform, Signal, computed } from '@angular/core';
import { select } from '@ngxs/store';
import { LocalizationState } from '../state/localization.state';
import { LocalizedDateTimeFormatKey } from '../types/localization-setting';
import { toLocalizedDateTimeRangeFormat } from '../utils/localized-date-time-format';
import { BaseLocalizedPlaceholderFormatPipe } from './base-localized-placeholder-format.pipe';

export interface BaseLocalizedDateTimeRangeFormatParams {
  start: string | Date | number | null | undefined;
  end: string | Date | number | null | undefined;
}

export abstract class BaseLocalizedDateTimeRangeFormatPipe
  extends BaseLocalizedPlaceholderFormatPipe<BaseLocalizedDateTimeRangeFormatParams>
  implements PipeTransform
{
  private readonly localizationSetting = select(
    LocalizationState.getLocalizationSetting,
  );
  private readonly dateFnsLocale = select(LocalizationState.getDateFnsLocale);

  protected abstract readonly formatType: LocalizedDateTimeFormatKey;

  transform({ start, end }: BaseLocalizedDateTimeRangeFormatParams): string {
    if (!start || !end) {
      return '';
    } else {
      return toLocalizedDateTimeRangeFormat(
        { start, end },
        this.localizationSetting(),
        this.formatType,
        this.dateFnsLocale(),
      );
    }
  }

  toFormattedSignal({
    start,
    end,
  }: BaseLocalizedDateTimeRangeFormatParams): Signal<string> {
    return computed(() => this.transform({ start, end }));
  }

  protected getPlaceholderInput(): BaseLocalizedDateTimeRangeFormatParams {
    return { start: new Date(), end: new Date() };
  }
}
